/**
 * 会员现状共享状态（阶段二）：/membership/me 结果单点缓存
 * - App 启动/token 变化时 refresh；学习页防复制/水印、加密缓存权益复核、原生截屏保护都读这里
 * - me=null 表示未登录或拉取失败 → 各处按"默认保护"降级（禁复制截屏、memberLevel 传给缓存层为 null 跳过复核）
 */
import { create } from 'zustand';
import { fetchMembershipMe, type MembershipMe } from '@shared/api/membership';

interface MembershipState {
  me: MembershipMe | null;
  /** 是否已完成一次拉取（区分"未加载"与"确认无会员"） */
  loaded: boolean;
  /** 拉当前用户会员现状；失败静默（me 置 null，默认保护） */
  refresh(token: string | null): Promise<void>;
}

export const useMembershipStore = create<MembershipState>((set) => ({
  me: null,
  loaded: false,
  refresh: async (token) => {
    const me = await fetchMembershipMe(token);
    set({ me, loaded: true });
  },
}));
